module.exports = __webpack_public_path__ + "static/media/close.d19385c7.svg";